import React, { Component } from "react";
import { connect } from "react-redux";

import "./styles.scss";
import { api } from "@/APIRequests";
import Button from "@/components/UI/Button";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import { Rating } from "@/components/UI/Rating";
import { getPatientProfile } from "@/redux/actions/auth";
import images from "@/utils/images";

class NPSSurvey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: "",
      rating: -1,
      showSuccess: false,
    };
  }

  onNumberClick = (rating) => {
    this.setState({ rating });
  };

  onTextUpdate = (event) => {
    this.setState({ comments: event.target.value });
  };

  onSubmit = async () => {
    if (this.state.rating < 0) {
      return;
    }

    let data = {
      comments: this.state.comments,
      rating: this.state.rating,
    };

    await api.patient.send_nps_survey_answers({ data });

    this.setState({ showSuccess: true });

    setTimeout(() => {
      this.props.getPatientProfile();
    }, 5000);
  };

  render() {
    if (this.state.showSuccess) {
      return (
        <CardSecondary className="NPSSurveyComplete">
          <img className="mt-5" src={images("./icons/circle-tick-success.svg")} />
          <p className="mt-3">
            <b>Feedback Submitted</b>
          </p>
          <p className="mb-5">Thank you for sharing your feedback with us!</p>
        </CardSecondary>
      );
    } else {
      return (
        <CardSecondary className="NPSSurvey">
          <p className="mt-5">
            <b>How likely is it that you would recommend aptihealth to a friend or colleague?</b>
          </p>
          <div className="w-100">
            <Rating
              currentRating={-1}
              onClick={this.onNumberClick}
              totalRating={11}
              type="number"
            />
            <div
              className="flex-sm-row justify-content-sm-around fs-12"
              style={{ width: 65 + "%" }}
            >
              <span className="float-left">Not likely</span>
              <span className="float-right">Very Likely</span>
            </div>
          </div>

          <p className="mt-3">
            <b>Comments</b> (Optional)
          </p>
          <textarea
            className="w-75"
            onChange={this.onTextUpdate}
            placeholder="Write your comments here.."
          />
          <div className="d-flex tw:justify-center mb-3 mt-5">
            <Button className="Btn Btn--pri Btn-sm" onClick={this.onSubmit} type="submit">
              Submit
            </Button>
          </div>
        </CardSecondary>
      );
    }
  }
}

export default connect(null, {
  getPatientProfile,
})(NPSSurvey);
